var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudentIcon = function SvgStudentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.687 5.184 8.156 2.527a.47.47 0 0 0-.312 0L.313 5.184a.469.469 0 0 0-.001.884l7.531 2.677a.47.47 0 0 0 .314 0l7.531-2.677a.469.469 0 0 0 0-.884m-.813 6.256V7.352l-.937.333v3.755a.941.941 0 0 0 0 1.633v2.303a.469.469 0 1 0 .937 0v-2.303a.94.94 0 0 0 0-1.633M7.53 9.63a1.4 1.4 0 0 0 .942 0l4.234-1.505v2.062c0 .505-.527.932-1.565 1.269-.905.293-2.02.455-3.14.455s-2.235-.162-3.14-.455c-1.038-.337-1.565-.764-1.565-1.269V8.124z",
    clipRule: "evenodd"
  })));
};
export default SvgStudentIcon;